import React from 'react';

export default ({ children }) => (
  <div className="wrap">
    { children }
  </div>
)
